import ZooPassLocalStateData from "../Data/ZooPassLocalStateData";
import {
    ZooPassContribIdItem,
    ZooPassLookupItem,
    ZooPassOfferingItem,
    ZooPassOfferingYearSetItem
} from "../Data/ZooContrib";
import ZooPassLocalStateUtility from "./ZooPassLocalStateUtility";
import { MemberDataDto } from "../Data/MemberDataDto";

export default class ZooPassStepDataUtility {



    public static GetDateFromIso8601(date: string | null | undefined): Date | null {
        if (date == undefined) return null;
        return new Date(date);
    }

    public static GetMembershipId(membership: ZooPassOfferingItem, isGift: boolean, year: 1 | 2 | 3): ZooPassContribIdItem {
        return isGift
            ? ZooPassStepDataUtility._getMembershipItemBySelection(membership.gift, year)
            : ZooPassStepDataUtility._getMembershipItemBySelection(membership.member, year)
    };

    private static _getMembershipItemBySelection(membershipItem: ZooPassOfferingYearSetItem, year: 1 | 2 | 3): ZooPassContribIdItem {
        if (year == 1) return membershipItem.y1
        if (year == 2) return membershipItem.y2
        return membershipItem.y3
    };
    
    public static SetStepDataFromRenewal(data: ZooPassLocalStateData, lookup: ZooPassLookupItem, children: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9): ZooPassLocalStateData {
        // const guestCalculation = ZooPassAnswerAvailabilityUtility.CalculateGuestOptionAvailability(data);
        let lookupGuests = lookup.guests;
        // if(!guestCalculation.options.includes(lookup.guests))
        // {
        //     lookupGuests = guestCalculation.options[0] as 0 | 1 | 2 | 3 | 4;
        //     console.log("Defaulted guests to: " + lookupGuests);
        // }
        data.step3Value = lookup.adults;
        data.step4Value = lookup.children ? (children > 4 ? 4 : children as (0 | 1 | 2 | 3 | 4)) : 0;
        data.step4DropdownValue = lookup.children ? (children < 4 ? 4 : children as (4 | 5 | 6 | 7 | 8 | 9)) : 4;
        data.step4FinalValue = children;
        data.step5Value = lookupGuests;
        // Parking is now always included; keep the field for backward compatibility.
        data.step6Value = 1;

        return data;
    }

    public static ClearDataForStep(data: ZooPassLocalStateData): ZooPassLocalStateData {
        if (data.step <= 6) {
            data.step6Value = 1;
        }

        if (data.step <= 5) {
            data.step5Value = null;
        }

        if (data.step <= 4) {
            data.step4Value = null;
            data.step4DropdownValue = 4;
            data.step4FinalValue = null;
        }

        return { ...data };
    }

    public static FixDataForStep(data: ZooPassLocalStateData): ZooPassLocalStateData {
        // Step 6 (parking) is no longer shown; migrate persisted state forward.
        if (data.step === 6) {
            data.step6Value = 1;
            data.step = 7;
        }
        // first set the step if there is something invalid
        if (data.step > 3 && data.step != 7 && !this.IsFormDataValid(data.formData, data.step3Value == 2, data.step1Value == 1)) {
            data.step = 3;
        }

        // deleting the second adult if not needed
        if (data.step3Value == 1 && data.formData && data.step != 7) {
            delete data.formData.adultFName2;
            delete data.formData.adultLName2;
        }

        if (data.step < 9) {
            data.finalizing = null;
        }

        if (data.step <= 8) {
            data.step8Value = null;
            data.step8IdValue = null;
        }

        // preserve the values that are set.  
        if (data.step <= 7) {
            data.step7Value = null;
        }

        if (data.step < 3) {
            data.step3Value = null;
        }

        if (data.step <= 2) {
            data.step2Value = null;
            data.step2RenewalPassId = null;
        }

        if (data.step <= 1) {
            data.step1Value = null;
            data.step = 1;
        }
        
        if (!(data.step1Value == 0 && data.step2Value == 1)) {
            //data.formData = ZooPassLocalStateUtility.DefaultFormData;
            data = this.ClearDataForStep(data);
        }


        return { ...data };
    }

    public static ValidateFormData(formData: MemberDataDto, require2Adults: boolean = false, isGift: boolean = true): { [key: string]: string; } {
        // Implement any form validation logic here if needed
        let validationMessages: {
            [key: string]: string;
        } = {};

        if (!formData.adultFName1 || formData.adultFName1.trim() === "") validationMessages.adultFName1 = "First name is required.";
        if (!formData.adultLName1 || formData.adultLName1.trim() === "") validationMessages.adultLName1 = "Last name is required.";

        if (require2Adults) {
            if (!formData.adultFName2 || formData.adultFName2.trim() === "") validationMessages.adultFName2 = "First name is required.";
            if (!formData.adultLName2 || formData.adultLName2.trim() === "") validationMessages.adultLName2 = "Last name is required.";
        }

        if (isGift) {
            if (!formData.recipAddress || formData.recipAddress.trim() === "") validationMessages.recipAddress = "Recipient address is required.";
            if (!formData.recipCity || formData.recipCity.trim() === "") validationMessages.recipCity = "Recipient city is required.";
            if (!formData.recipState || formData.recipState.trim() === "") validationMessages.recipState = "Recipient state is required.";
            if (!formData.recipPostal || formData.recipPostal.trim() === "") validationMessages.recipPostal = "Recipient zip is required.";

            if (!formData.recipPhone) validationMessages.recipPhone = "Recipient phone is required.";

            if (formData.recipPhone && formData.recipPhone.trim() !== "" && !/^\d{10,}$/.test(formData.recipPhone.replace(/\D/g, ''))) validationMessages.recipPhone = "Recipient phone is invalid.";
            if (formData.recipEmail && formData.recipEmail.trim() !== "" && !/^\S+@\S+\.\S+$/.test(formData.recipEmail)) validationMessages.recipEmail = "Recipient email is invalid.";
        }
        return validationMessages;
    }

    public static IsFormDataValid(formData?: MemberDataDto, require2Adults: boolean = false, isGift: boolean = true): boolean {
        if (!formData) return false;
        return Object.keys(this.ValidateFormData(formData, require2Adults, isGift)).length === 0;
    }
}